import { FETCH_HOMEPAGE } from '../actions/types';

const INITIAL_STATE = [];

export const headerStaticReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case FETCH_HOMEPAGE:
			const { homepage } = action.payload;

			homepage.headerStatic.forEach((image, key) => {
				state[key] = image;
			});

			return state;

		default:
			return state;
	}
};
